import { combineReducers } from "redux";

// import reducers
import postsReducer from "./postReducer";
// import authors from './authorReducer';
import activitiesReducer from "./activitiesReducer";
import adminCommunicationsReducer from "./adminCommunicationsReducer";
import appointmentsReducer from "./appointmentsReducer";
import associationsReducer from "./associationsReducer";
import authReducer from "./authenticationReducer";
import availabilitiesReducer from "./availabilitiesReducer";
import competitionReducer from "./competitionReducer";
import gameConfigReducer from "./gameConfigReducer";
import gameReducer from "./gameReducer";
import importReducer from "./importReducer";
import payrateReducer from "./payratesReducer";
import personsLoadReducer from "./persons/personsLoadReducer";
import personsReducer from "./persons/personsReducer";
import shiftEnrolmentsReducer from "./shifts/shiftEnrolmentsReducer";
import shiftReducer from "./shifts/shiftReducer";
import shiftSessionsReducer from "./shifts/shiftSessionsReducer";
import teamReducer from "./teamReducer";
import tokenReducer from "./tokenReducer";
import venuesReducer from "./venuesReducer";

// bind reducers
const rootReducer = combineReducers({
  posts: postsReducer,
  auth: authReducer,
  associations: associationsReducer,
  shifts: shiftReducer,
  shiftSessions: shiftSessionsReducer,
  shiftEnrolments: shiftEnrolmentsReducer,

  persons: personsReducer,
  personsLoad: personsLoadReducer,

  imports: importReducer,
  games: gameReducer,
  teams: teamReducer,
  competitions: competitionReducer,
  venues: venuesReducer,
  payrates: payrateReducer,
  tokens: tokenReducer,
  activities: activitiesReducer,
  gameConfigurations: gameConfigReducer,
  appointments: appointmentsReducer,
  availabilities: availabilitiesReducer,
  adminCommunications: adminCommunicationsReducer,
});

export default rootReducer;
